import React from "react";
import { useTranslation } from "react-i18next";

export const ResultCount = ({ count }: { count: number }) => {
  const { t } = useTranslation();
  return (
    <div className='px-2 flex items-center text-xs'>
      {t(`common.results.${count === 1 ? 'single' : 'multiple'}`, { num: count.toLocaleString() })}
    </div>
  );
}